import { render, staticRenderFns } from "./invite_member_button.vue?vue&type=template&id=5bc96698&scoped=true&"
import script from "./invite_member_button.vue?vue&type=script&lang=js&"
export * from "./invite_member_button.vue?vue&type=script&lang=js&"
import style0 from "./invite_member_button.vue?vue&type=style&index=0&id=5bc96698&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc96698",
  null
  
)

export default component.exports